import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { defineComponent, onMounted } from 'vue'
import { Image as VanImage, Divider, Field, Button } from 'vant'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const bg = require('../../assets/img/loginBg.jpg')
// defineComponent 在TS中 做类型推论  和类型限制

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(VanImage), {
      src: _unref(bg),
      width: "100%"
    }, null, 8, ["src"])
  ]))
}
}

})